import {PIN_DIRECTION} from '@/globals';

export interface EquipmentConnectorPinModel {
    id: string;
    title: string;
    locationId: string;
    pinDirection: PIN_DIRECTION;
    created: string;
    equipmentPinIds?: string[];
    equipmentConnectorPinIds?: string[];
    isActive: boolean;
    sortOrder: number;

    // constructor(data: Partial<EquipmentPinModel>) {
    //     Object.assign(this, data);
    // }
}

export class CreateEditEquipmentConnectorPinViewModel implements Omit<EquipmentConnectorPinModel, 'id' | 'locationId' | 'isActive' | 'created'> {
    id?: string;
    title: string;
    pinDirection: PIN_DIRECTION;
    equipmentPinIds?: string[];
    equipmentConnectorPinIds?: string[];
    sortOrder: number;

    constructor(data: CreateEditEquipmentConnectorPinViewModel) {
        Object.assign(this, data);
    }
}

export interface UpdateConnectorPinSortOrderEquipmentCapModel {
    dragedPinId: string;
    targetPinId: string;
    where: 'before' | 'after';
}
